/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S4_Li4Inputs */

const tr_onbilgi_s4_li4 = /** @type {(inputs: Onbilgi_S4_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm kart işlemleri 3D Secure protokolü ile gerçekleştirilir.`)
};

const en_onbilgi_s4_li4 = /** @type {(inputs: Onbilgi_S4_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All card transactions are carried out using the 3D Secure protocol.`)
};

const de_onbilgi_s4_li4 = /** @type {(inputs: Onbilgi_S4_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Kartentransaktionen werden mit dem 3D-Secure-Protokoll durchgeführt.`)
};

const ru_onbilgi_s4_li4 = /** @type {(inputs: Onbilgi_S4_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все операции по картам выполняются по протоколу 3D Secure.`)
};

/**
* | output |
* | --- |
* | "All card transactions are carried out using the 3D Secure protocol." |
*
* @param {Onbilgi_S4_Li4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s4_li4 = /** @type {((inputs?: Onbilgi_S4_Li4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S4_Li4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s4_li4(inputs)
	if (locale === "de") return de_onbilgi_s4_li4(inputs)
	if (locale === "ru") return ru_onbilgi_s4_li4(inputs)
	return tr_onbilgi_s4_li4(inputs)
});